<template>
  <div class="pc-layout">
    <PcHeader v-if="showNav" />
    <PcSidebar v-if="showPcSidebar" @to-top="onSidebarToTop" />
    <main class="pc-main" :class="{ 'pc-main--with-nav': showNav }">
      <transition name="pc-page" mode="out-in" @after-leave="onPageAfterLeave">
        <router-view :key="$route.path" />
      </transition>
    </main>
    <PcFooter v-if="showFooter" />
  </div>
</template>

<script>
import { setPcRem, clearPcRem } from '@/utils/rem-pc'
import PcHeader from './components/PcHeader.vue'
import PcFooter from './components/PcFooter.vue'
import PcSidebar from './components/PcSidebar.vue'

export default {
  name: 'PcLayout',
  data() {
    return {
      deferScrollResetAfterEnter: false
    }
  },
  components: {
    PcHeader,
    PcFooter,
    PcSidebar
  },
  watch: {
    $route(to, from) {
      const fromHome = from && from.path === '/'
      const toPcChild = to.path !== '/'
      this.deferScrollResetAfterEnter = fromHome && toPcChild
    }
  },
  computed: {
    showNav() {
      return this.$route.meta.showNav !== false
    },
    showFooter() {
      return this.$route.meta.showFooter !== false
    },
    /** 与 PcHeader 同理：由路由 meta 控制，默认不展示 */
    showPcSidebar() {
      return this.$route.meta.showPcSidebar === true
    }
  },
  methods: {
    onPageAfterLeave() {
      if (!this.deferScrollResetAfterEnter) return
      this.deferScrollResetAfterEnter = false
      window.scrollTo({ top: 0, behavior: 'auto' })
    },
    /** 侧栏「回顶」：任意带侧栏的 PC 页统一滚动窗口顶部 */
    onSidebarToTop() {
      if (typeof window === 'undefined') return
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)')
        .matches
        ? 'auto'
        : 'smooth'
      window.scrollTo({ top: 0, behavior })
    },
  },
  mounted() {
    setPcRem()
    window.addEventListener('resize', setPcRem)
  },
  beforeDestroy() {
    window.removeEventListener('resize', setPcRem)
    clearPcRem()
  }
}
</script>

<style scoped>
.pc-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  line-height: 1.5;
  color: #333;
}
.pc-main {
  flex: 1;
}

/* 子路由切换：淡入淡出 */
.pc-page-enter-active,
.pc-page-leave-active {
  transition: opacity 0.5s ease;
}
.pc-page-enter,
.pc-page-leave-to {
  opacity: 0;
}

@media (prefers-reduced-motion: reduce) {
  .pc-page-enter-active,
  .pc-page-leave-active {
    transition-duration: 0.2s;
  }
}
</style>
